'use client';
import { AmplienceFooterProps } from 'components/amplience/footer';
import { AmplienceMegaNavProps } from 'components/amplience/header-nav/components/mega-nav';
import GTMPageViewTracker from 'components/analaytics/gtm-page-view-tracker';
import useAmplience from 'frontastic/hooks/useAmplience';
import { useEffect, useState } from 'react';
import Header from '../header';
import AmplienceDynamicComponent from 'components/amplience/dynamic-component';
import Footer from '../footer';
import { sdk } from 'sdk';
import dynamic from 'next/dynamic';

const GASnippet = dynamic(() => import('components/Scripts/GASnippet'));

const NotFound = () => {
  sdk.defaultConfigure('en');

  const [isMounted, setIsMounted] = useState<boolean>(false);
  const { getContentByDeliveryKey } = useAmplience();
  const [referrer, setReferrer] = useState<string>();
  const [amplienceContent, setAmplienceContent] = useState(undefined);
  const [megaNavData, setMegaNavData] = useState<AmplienceMegaNavProps[] | undefined>(undefined);
  const [footerNavData, setFooterNavData] = useState<AmplienceFooterProps | undefined>(undefined);

  useEffect(() => {
    async function headerNav() {
      const res = await getContentByDeliveryKey('header-nav');
      setMegaNavData(res.amplienceContent?.megaNavs);
    }

    async function getFooterNavData() {
      const res = await getContentByDeliveryKey('footer');
      setFooterNavData(res.amplienceContent);
    }
    async function getContent() {
      const res = await getContentByDeliveryKey('not-found');

      setAmplienceContent(res.amplienceContent);
    }

    if (isMounted) {
      setReferrer(
        decodeURIComponent(
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('lastPath='))
            ?.split('=')[1] ?? '',
        ),
      );
      getContent();
      headerNav();
      getFooterNavData();

      window.history.replaceState({ shallow: true }, '', '/not-found');
    }
  }, [isMounted]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (amplienceContent && megaNavData && footerNavData) {
    return (
      <div data-theme="default">
        <GASnippet />
        <GTMPageViewTracker pageTypeVal="not-found" referer={referrer === '/not-found' ? '' : (referrer ?? '')} />
        <div>
          <Header dataSource={{ dataSource: { megaNavs: megaNavData as any } }} />
        </div>

        <div className="block px-4 md:block lg:mx-auto lg:block lg:max-w-[--page-max-width]">
          <AmplienceDynamicComponent data={amplienceContent} />
        </div>
        <Footer
          data={{
            megaNav: footerNavData.megaNav,
            newsletterCopy: footerNavData.newsletterCopy,
            siteIntegrityGroup: footerNavData.siteIntegrityGroup,
            socialsGroup: footerNavData.socialsGroup,
          }}
        />
      </div>
    );
  }
  return null;
};

export default NotFound;
